import clsx from 'clsx'
import Nav from 'react-bootstrap/esm/Nav'
import NavItem from 'react-bootstrap/esm/NavItem'
import { Link } from 'react-router-dom'
import { useParams } from 'react-router-dom'
import styled from 'styled-components'
import { ParamsType } from '../../model/model'
import { useAppSelector } from '../../store/store'

const StyledLink = styled(Link)`
  font-size: 0.8rem;
  padding: 0.25rem 0.5rem !important;
  color: #fff !important;

  &.active {
    color: #495057 !important;
  }
`

const BeltSelectorDesktop = () => {
  const belts = useAppSelector((store) => store.belt)
  const { userID, activeTab } = useParams<ParamsType>()

  return (
    <Nav variant='tabs' className='d-flex'>
      {belts.list.map((tab) => {
        const title = belts.idMap[tab.id]

        return (
          <NavItem key={tab.id}>
            <StyledLink
              to={(userID ? `/user/${userID}/` : '') + title}
              className={clsx('nav-link', {
                active: activeTab === title
              })}
            >
              {tab.title}
            </StyledLink>
          </NavItem>
        )
      })}
    </Nav>
  )
}

export default BeltSelectorDesktop
